import {
    EDIT_ON_HOLD_RELEASE_DATE_REQUEST,
    EDIT_ON_HOLD_RELEASE_DATE_SUCCESS,
    EDIT_ON_HOLD_RELEASE_DATE_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editOnHoldReleaseDateReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_ON_HOLD_RELEASE_DATE_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_ON_HOLD_RELEASE_DATE_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_ON_HOLD_RELEASE_DATE_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editOnHoldReleaseDateReducer;
